import React from 'react';
import { useTranslation } from 'react-i18next';

const SelectLanguage = () => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language || 'fr';

    const handleChange = (event) => {
        const lng = event.target.value;
        i18n.changeLanguage(lng);
    };

    return (
        <div className={`bg-primary ${i18n.language === "ar" ? 'pl-4 ml-4' : 'pr-4 mr-4'}  rounded-sm hover:scale-110 ease-in-out duration-500`}>
            <select className="bg-primary text-white text-sm px-4 py-3 shadow-none rounded-sm font-medium" value={currentLanguage} onChange={handleChange}>
                <option value="fr">FRANCAIS</option>
                <option value="ar">عربية</option>
            </select>
        </div>
    );
};

export default SelectLanguage;
